import React from "react";
import PropTypes from "prop-types";
import PublicCatalogLayout from "../../layouts/PublicCatalogLayout"
import ItemCard from "../components/ItemCard"
import Cookies from "universal-cookie";
import {isJaguar, isSuperadmin} from '../../utility/UserUtils.js'
import { Button } from '@mui/material';
class ItemSearchDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      tagsOpen: false,
      commonTags: null,
      selectedTags: [],
      searchInput: props.search || "",
      loading: true,
    }

    this.toggleTags = this.toggleTags.bind(this);
    this.toggleSelectedTag = this.toggleSelectedTag.bind(this);
    this.updateSearchInput = this.updateSearchInput.bind(this);
    this.loadTags = this.loadTags.bind(this);
    this.getSearchItems = this.getSearchItems.bind(this);
  }

  componentDidMount() {
    this.loadTags();
    this.getSearchItems( null );
  }

  getSearchItems(e) {
    if(e){
      e.preventDefault();
    }
    this.setState({loading: true});
    const {searchInput} = this.state;
    const cookies = new Cookies();
    const token = cookies.get("X-CSRF-Token");
    fetch(`/items/get_search_items?query=${searchInput.trim()}`, {
      method: 'GET',
      redirect: "manual",
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": 'application/json'
      }
    })
    .then(response => {
      return response.json();
    })
    .then(json => {
      console.log(json)
      if (json.error == null) {
        this.setState({items: json.items || [], loading: false});
        window.history.replaceState(null, null, this.generateSearchLink());
      } else {
        alert(json.error);
      }
    });
  }

  renderSearchForm() {
    const { searchInput } = this.state;
    return (
      <div className="row">
        <div className="col-xs-12">
          <form onSubmit={this.getSearchItems}>
            <div className="search-menu-card" style={{paddingTop: "20px"}}>
              <h2> Search: </h2>
              <br />
              <div className="row">
                <div className="col-xs-8">
                  <input value={searchInput} onChange={this.updateSearchInput} className="form-control"/>
                </div>
                <div className="col-xs-4">
                  <Button color="green" variant="contained" type="submit">Search</Button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    )
  }

  generateSearchLink(){
    const { searchInput, selectedTags } = this.state;
    const tags = selectedTags.map(tag => `tags[]=${tag}`);
    const params = [`query=${searchInput}`].concat(tags).join('&');
    return `/items/search?${params}`
  }

  loadTags() {
    const cookies = new Cookies();
    const token = cookies.get("X-CSRF-Token");
    fetch(`/item_tags/common_tags?count=25`, {
      method: 'GET',
      redirect: "manual",
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": 'application/json'
      }
    })
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.error == null) {
          this.setState({commonTags: json.tags || []});
        } else {
          alert(json.error);
        }
      });
  }

  updateSearchInput(e){
    this.setState({
      searchInput: e.target.value
    })
  }

  toggleTags() {
    const { tagsOpen } = this.state;
    this.setState({
      tagsOpen: !tagsOpen
    })
  }

  toggleSelectedTag(tag) {
    const { selectedTags } = this.state;
    this.setState({
      selectedTags: ((selectedTags.indexOf(tag) > -1) ? selectedTags.filter(tag2 => tag2 != tag) : [tag].concat(selectedTags))
    })
  }

  getTagClass(tag) {
    const { selectedTags } = this.state;
    return selectedTags.indexOf(tag) > -1 ? "active" : "";
  }

  renderTags() {
    const { tagsOpen, commonTags} = this.state;
    let content = ""
    if(tagsOpen && commonTags) {
      content = commonTags.map(tag => (
          <span className="selectable-tag" onClick={() => this.toggleSelectedTag(tag)}>
            <div className={`tag-container ${this.getTagClass(tag)}`} >
              {tag}
            </div>
          </span>
        )
      )
    }
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-xs-12 archive-events-header" onClick={this.toggleTags}>
            Tags&nbsp;&nbsp;
            {tagsOpen ?
              (<i class="fas fa-sort-down" />)
              :
              (<i class="fas fa-sort-down archive-arrow-rotated" />)
            }
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 search-tags-container" >
            { content }
          </div>
        </div>
      </React.Fragment>
    )
  }

  renderItems() {
    const { user } = this.props;
    const { items, searchInput } = this.state;
    return items.map(item => (
      <ItemCard key={`item-card-${item.id}`} user={user} item={item} />
    )); 
  }

  render() {
    const { group, search } = this.props;
    return (
      <PublicCatalogLayout
        currentPage={`search`}
        {...this.props}
        className="category-dashboard"
      >
        {this.renderSearchForm()}
        {this.renderItems()}
      </PublicCatalogLayout> 
    );
  }
}

ItemSearchDashboard.propTypes = {
  items: PropTypes.array.isRequired,
};

export default ItemSearchDashboard;
